import { createNonceStr, md5 } from '@/utils/utils'
//分享外部签名
let appKey = 'share_h5';
let secret = 'db6322f0-0660-4228-8f98-ae24b51c98dc';
let timestamp = new Date().getTime();
let random = createNonceStr();
let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}`;
let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
 //eslint-disable-next-line
export default{
  sign_share : {
    'appKey' : appKey,
    'timestamp' : timestamp,
    'random' : random,
    'sign' : sign
  },
}